import React from "react";

export interface LayerManagerProps {
  background?: React.ReactNode;
  main?: React.ReactNode;
  overlay?: React.ReactNode;
}

// Simple, deterministic layer stack: background → main → overlay.
// Renderer still knows nothing about flows; it just creates groups.
export const LayerManager: React.FC<LayerManagerProps> = ({ background, main, overlay }) => {
  return (
    <>
      <g data-layer="background">{background}</g>
      <g data-layer="main">{main}</g>
      <g data-layer="overlay">{overlay}</g>
    </>
  );
};
